import FilterCard from "./FilterCard";
import { useAppDispatch } from "../../hooks/redux";
import { getSelectedCourseYears, setSelectedCourseYears } from "../../services/students/studentsSlice";
import { useSelector } from "react-redux";
import FilterBox from "./FilterBox";

const courseYear = [
  { course: 1 },
  { course: 2 },
  { course: 3 },
  { course: 4 },
  { course: 5 },
  { course: 6 },
];

const CourseYearFilter = (props: any) => {
  const selectedCourseYears = useSelector(getSelectedCourseYears);
  const dispatch = useAppDispatch();

  return (
    <FilterCard title="По курс:">
      <FilterBox<any>
        value={selectedCourseYears}
        onChange={(e) => dispatch(setSelectedCourseYears(e.value as any[] & void))}
        options={courseYear}
        dataKey="course"
        optionLabel="course"
        listClassName="max-h-12rem"
        horizontal
      />
    </FilterCard>
  );
};

export default CourseYearFilter;
